import styled from 'styled-components';

export const PlainButton = styled.button`
  border: none;
  background: transparent;
`;

export { default as Info } from './Info';
